import PageLayout, { siteTitle } from "@/components/PageLayout";
import ApplicationPhotoTile from '@/components/inspiration/application_photos/application_photo_tile.js';
import ApplicationPhotoService from '@/lib/services/application_photos';
import searchTranslator from "@/lib/search_translator.js";
import { loadConfig } from "@/lib/utils.js";
import Link from "next/link";
import { cameraIcon, pictureIcon } from "@/lib/icons";
import ApplicationGalleryTile from "@/components/inspiration/galleries/application_gallery_tile";
import SearchToggle from "@/components/inspiration/search_toggle";
import Lightbox from "@/components/lightbox";
import { useState } from "react";
import { is_mobile } from "@/lib/utils.js";

export default function ApplicationPhotoSearchPage(results){
  const {
    latest_photos, 
    page_layout,
    favicon,
    stylesheet,
    cart_enabled,
    latest_galleries,
    inspiration_display,
    mobile
  } = results;

  const [lightBoxIndex, setLightBoxIndex] = useState(null);
  const [imageToShow, setImageToShow] = useState('');

  const showLightBox = (e, photo) => {
    e.stopPropagation();
    setImageToShow(photo);
    setLightBoxIndex(0);
  }

  const hideLightBox = () => {
    setLightBoxIndex(null);
    setImageToShow('');
    document.body.style.overflow = "visible";
  }

  return (
    <PageLayout
      title="Inspiration Search"
      page_layout={page_layout}
      cart_enabled={cart_enabled}
      favicon={favicon}
      stylesheet={stylesheet}
    >
      <div className='lexcms-inspiration-highlights'>
        <div className='lexcms-inspiration-search-container'>
          <div className="lexcms-inspiration-search-header-text">
            <h1>Inspirational Search</h1>
            <p>Discover awe-inspiring images from our projects.</p>
          </div>
          <div className='lexcms-inspiration-sidebar-filters'>
            <SearchToggle display={inspiration_display} />
          </div>
        </div>
        <div className='highlight-result-container'>
          { latest_galleries && latest_galleries.length > 0 && 
            <div className='lexcms-inspiration-highlight-photos-container lexcms-latest-galleries-container'>
              <h4 className='lexcms-inspiration-highlight-title lexcms-latest-galleries-title'>Latest Galleries</h4>
              <div className='lexcms-inspiration-highlight-application-photos lexcms-latest-galleries-contents'>
                { latest_galleries?.map((gallery, i) => {
                    return <ApplicationGalleryTile key={i} app_gallery={gallery} mobile={mobile} />
                  })
                }
              </div>
              <Link href='/lex-cms/inspiration/latest_galleries/index'>
                <a className='lexcms-latest-photos-link'>View All Latest Galleries</a>
              </Link>
            </div>
          }
          { latest_photos && latest_photos.length > 0 &&
            <div className='lexcms-inspiration-highlight-photos-container'>
              <h4 className='lexcms-inspiration-highlight-title'>Latest Photos</h4>
              <div className='lexcms-inspiration-highlight-application-photos'>
                { latest_photos?.map((photo, i) => {
                    return <ApplicationPhotoTile key={i} app_photo={photo} index={i} showLightBox={showLightBox} highlight={true} mobile={mobile} />
                  })
                }
              </div>
              <Link href='/lex-cms/inspiration/latest_photos/index'>
                <a className='lexcms-latest-photos-link'>View All Latest Photos</a>
              </Link>
            </div>
          }
        </div>
        <Lightbox index={lightBoxIndex} images={[imageToShow]} hideLightBox={hideLightBox} />
      </div>
    </PageLayout>
  )
}

export async function getServerSideProps(context) {

  
  let token = context.req?.headers['lex-api-token'];
  let service = await ApplicationPhotoService.build(
    token,
    context.req?.headers.host
  );
  let q = searchTranslator(context.query);
  let apiFriendlyQ = searchTranslator(context.query, true);
  let search = await service.highlights(apiFriendlyQ);
  search.initialSearch = q;
  let pageConfig = loadConfig(service);
  let mobile = is_mobile(context.req?.headers['user-agent'])

  return {
    props: { ...search, ...pageConfig, mobile: mobile },
  };
}
